module.exports = __webpack_public_path__ + "static/media/COS_TOOLS_1.eaecbf36.jpg";